// This function creates a div element that will be used to contain the input
export const getWidgetContainer = (w = '100%', col = false, nomargin = false, tabletView = false) => {
	const widgetContainer = document.createElement('div');
	widgetContainer.style.width = w;
	widgetContainer.style.display = 'flex';
	widgetContainer.style.flexWrap = 'wrap';
	widgetContainer.style.gap = '0.5rem';
	if (col) {
		widgetContainer.style.flexDirection = 'column';
		widgetContainer.style.gap = '1rem';
	}
	widgetContainer.style.justifyContent = 'center';
	widgetContainer.style.alignItems = 'center';
	if (!nomargin) widgetContainer.style.marginTop = 'var(--margin-3)';
	if (tabletView) {
		widgetContainer.style.justifyContent = 'flex-start';
		widgetContainer.style.marginTop = 'var(--margin-2)';
		widgetContainer.style.width = '100%';
	}
	widgetContainer.style.left = 'unset';
	return widgetContainer;
};

/**
 * @description Get the geocode position from the placeId or latlng
 */
export const getGeocodePosition = async ({ lat, lng, placeId }) => {
	const maps = window?.google?.maps;

	// don't do anything if the maps is not loaded
	if (!maps) return;

	const latLng = new maps.LatLng(lat, lng);
	const { Geocoder } = await maps.importLibrary('geocoding');
	const geocoder = new Geocoder();

	const requestBody = placeId ? { placeId } : { location: latLng };
	const { results } = await geocoder.geocode(requestBody);
	let selected = results[0];
	if (results[0] && results.length > 1) {
		for (let i = 0; i < results.length; i += 1) {
			if (!results[i].types.includes('plus_code')) {
				selected = results[i];
				break;
			}
		}
	}

	if (selected) {
		const { address_components: addressComponents, formatted_address: text, geometry } = selected;

		const city =
			addressComponents?.find(({ types }) => types.includes('locality'))?.short_name ??
			addressComponents.find(({ types }) => types.includes('postal_town'))?.short_name ??
			addressComponents?.find(({ types }) => types.includes('administrative_area_level_1'))?.short_name;
		const country = addressComponents?.find(({ types }) => types.includes('country'))?.short_name;
		const zipCode = addressComponents?.find(({ types }) => types.includes('postal_code'))?.short_name;

		const resultLat = geometry?.location?.lat();
		const resultLng = geometry?.location?.lng();

		return { text, city, country, zipCode, lat: resultLat, lng: resultLng };
	}

	return { lat, lng };
};

export const getCityCoordinates = async (cityName) => {
	const maps = window.google.maps;
	const geocoder = new maps.Geocoder();

	try {
		const results = await new Promise((resolve, reject) => {
			geocoder.geocode({ address: cityName }, (results, status) => {
				if (status === maps.GeocoderStatus.OK) {
					resolve(results);
				} else {
					reject(`Geocoding failed: ${status}`);
				}
			});
		});

		const location = results[0].geometry.location;
		const viewport = results[0].geometry.viewport;

		const bounds = {
			sw: {
				lat: viewport.getSouthWest().lat(),
				lng: viewport.getSouthWest().lng()
			},
			ne: {
				lat: viewport.getNorthEast().lat(),
				lng: viewport.getNorthEast().lng()
			}
		};

		const zoom = 11;

		return {
			lat: location.lat(),
			lng: location.lng(),
			bounds,
			zoom
		};
	} catch (error) {
		throw new Error(error);
	}
};

export const getPlaceDetails = async ({ lat, lng, placeId }) => {
	const maps = window?.google?.maps;

	// don't do anything if the maps is not loaded
	if (!maps) return;

	const latLng = new maps.LatLng(lat, lng);
	const { Geocoder } = await maps.importLibrary('geocoding');
	const geocoder = new Geocoder();

	const requestBody = placeId ? { placeId } : { location: latLng };
	const { results } = await geocoder.geocode(requestBody);
	return results[0];
};

export const getAddressByGeocode = (value) => {
	const { address_components: addressComponents, formatted_address: text, geometry } = value;

	const city =
		addressComponents?.find(({ types }) => types.includes('locality'))?.short_name ??
		addressComponents.find(({ types }) => types.includes('postal_town'))?.short_name ??
		addressComponents?.find(({ types }) => types.includes('administrative_area_level_1'))?.short_name;
	const country = addressComponents?.find(({ types }) => types.includes('country'))?.short_name;
	const zipCode = addressComponents?.find(({ types }) => types.includes('postal_code'))?.short_name;

	const resultLat = geometry?.location?.lat();
	const resultLng = geometry?.location?.lng();

	return { text, city, country, zipCode, lat: resultLat, lng: resultLng };
};
